import { LEGACY_STATUS_TO_CATEGORY } from '@modules/tarefas/constants/Text'
import { taskStatusId } from '@modules/tarefas/utils/optimisticStatusMove'

// Helpers privados compartilhados pelos dois modulos de getters.
// NAO sao reexportados pelo barrel `getters.js` — se fossem, virariam
// getters no store Vuex (`export const getters = { ...g }` em index.js).

// Builds an `id -> statusObject` map from a folder's statuses slice so the
// bucketing / column / chip getters resolve a task's `statusId` in O(1).
export function _statusMapById(statuses) {
  const map = {}
  if (!Array.isArray(statuses)) return map
  for (const s of statuses) {
    if (s && s.id != null) map[s.id] = s
  }
  return map
}

// Achata TODAS as fatias de status já carregadas (`statusesByFolder`) numa
// lista única. Ids de status são UUID por pasta, então o mapa achatado não
// colide. Usado pela visão rápida (cross-pasta), que não tem pasta ativa e
// portanto não pode resolver categoria por `activeFolderStatuses`.
export function _loadedStatuses(state) {
  const byFolder = (state && state.statusesByFolder) || {}
  const out = []
  for (const folderId of Object.keys(byFolder)) {
    const list = byFolder[folderId]
    if (!Array.isArray(list)) continue
    for (const status of list) {
      if (status && status.id != null) out.push(status)
    }
  }
  return out
}

// Resolves a task's category from the folder statuses map, tolerant of the
// transitional `task.status` literal (pre-migration data / tests) which maps
// 1:1 to a category. Returns null when unresolvable.
export function _taskCategory(task, statusMap) {
  if (!task) return null
  const sid = taskStatusId(task)
  if (sid != null && statusMap[sid]) return statusMap[sid].category || null
  // Cross-folder (quick-view) fallback: the payload embeds the backend-resolved
  // `statusCategory` so tasks from folders whose status slice isn't loaded still
  // bucket correctly. Only consulted when the active folder's map can't resolve
  // the task (folder mode always resolves via `statusMap` above → no change).
  if (task.statusCategory != null) return task.statusCategory
  if (task.status != null) return LEGACY_STATUS_TO_CATEGORY[task.status] || null
  return null
}
